var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.items)?_c('div',{style:({ display: 'flex' })},_vm._l((_vm.items),function(item,index){return _c('btn-header',{key:index,attrs:{"icon":item.icon,"href":item.link,"items":item.childrens}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }